import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ReactiveFormsModule } from '@angular/forms'
import { Tv3PlatformModule } from '@tokeet/tv3-platform'
import { MatTableModule } from '@angular/material/table'
import { MatSortModule } from '@angular/material/sort'
import { MatTooltipModule } from '@angular/material/tooltip'
import { MatPaginatorModule } from '@angular/material/paginator'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { ImageTableComponent } from './image-table.component'
import { PermissionModule } from '@tokeet-frontend/permission'
import { BsDropdownModule } from 'ngx-bootstrap/dropdown'

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    Tv3PlatformModule,
    MatTableModule,
    MatSortModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatCheckboxModule,
    PermissionModule,
    BsDropdownModule,
  ],
  declarations: [ImageTableComponent],
  providers: [],
  exports: [ImageTableComponent],
})
export class ImageTableModule {}
